export default function authGuard(to, from, next) {
  const token = localStorage.getItem("token");
  const tokenExp = localStorage.getItem("token_exp");

  if (!token || !tokenExp) {
    console.error("Erro: Token ausente ou expiração não definida.");
    setTimeout(() => {
      window.location.reload();
    }, 100);

    return next({ name: "Login" });
  }

  const now = Math.floor(Date.now() / 1000);

  if (now > tokenExp) {
    console.warn("Aviso: Token expirado. Redirecionando para login.");
    localStorage.removeItem("token");
    localStorage.removeItem("token_exp");
    localStorage.removeItem("feature_flags");
    localStorage.removeItem("company_plan");
    alert("Sua sessão expirou. Faça login novamente.");
    return next({ name: "Login" });
  }

  const featureKey = to.meta?.feature;

  if (featureKey) {
    try {
      const rawFlags = localStorage.getItem("feature_flags");
      if (rawFlags) {
        const flags = JSON.parse(rawFlags);
        const feature = flags?.[featureKey];

        if (feature && feature.enabled === false) {
          alert(feature.message || "Módulo exclusivo para o Plano Performance");
          return next({ name: "Dashboard" });
        }
      }
    } catch (error) {
      console.error("Erro ao validar feature no authGuard:", error);
    }
  }

  next();
}